/**
 * Campaign banner section: mobile disclaimer close, desktop overlay, carousel slots and nav button states.
 * Sections are found via .campaign-banners[data-section-id]; config comes from the DOM (no Liquid in this file).
 */
(function () {
  function init(sectionEl) {
    if (!sectionEl || !sectionEl.dataset.sectionId) return;

    sectionEl.addEventListener('click', function (e) {
      if (window.innerWidth >= 768) return;
      var openDisclaimer = sectionEl.querySelector('.campaign-banners__disclaimer.is-open');
      if (!openDisclaimer) return;
      var clickedDisclaimer = e.target.closest('.campaign-banners__disclaimer');
      var clickedIcon = e.target.closest('.campaign-banner__icon-wrapper');
      if (clickedIcon) return;
      openDisclaimer.classList.remove('is-open');
      openDisclaimer.setAttribute('hidden', '');
      openDisclaimer.setAttribute('aria-hidden', 'true');
    });

    function isDesktop() {
      return window.matchMedia('(min-width: 768px)').matches;
    }

    var overlay = sectionEl.querySelector('.campaign-banners__disclaimer-overlay');
    var overlayStyle = overlay ? overlay.style : null;

    function positionOverlay(bannerEl, text) {
      if (!overlay || !overlayStyle || !text) return;
      overlay.textContent = text;
      overlay.classList.add('is-visible');
      overlay.removeAttribute('hidden');
      overlay.setAttribute('aria-hidden', 'false');
      var rect = bannerEl.getBoundingClientRect();
      var pad = 4;
      overlayStyle.top = (rect.bottom + pad) + 'px';
      overlayStyle.left = rect.left + 'px';
      overlayStyle.width = Math.max(rect.width, 100) + 'px';
      overlayStyle.minWidth = '100px';
    }

    function hideOverlay() {
      if (!overlay) return;
      overlay.classList.remove('is-visible');
      overlay.setAttribute('hidden', '');
      overlay.setAttribute('aria-hidden', 'true');
      overlay.textContent = '';
    }

    sectionEl.querySelectorAll('.campaign-banner-group').forEach(function (group) {
      var icon = group.querySelector('.campaign-banner__icon-wrapper');
      var disclaimerEl = group.querySelector('.campaign-banners__disclaimer');
      var bannerEl = group.querySelector('.campaign-banner');
      var disclaimerTextEl = disclaimerEl ? disclaimerEl.querySelector('.campaign-banners__disclaimer-text') : null;
      var disclaimerText = disclaimerTextEl ? disclaimerTextEl.textContent : '';
      if (!disclaimerText && !icon && !disclaimerEl) return;

      function addVisible() {
        if (!isDesktop()) return;
        if (overlay && disclaimerText && bannerEl) {
          positionOverlay(bannerEl, disclaimerText);
        } else if (disclaimerEl) {
          disclaimerEl.removeAttribute('hidden');
          disclaimerEl.setAttribute('aria-hidden', 'false');
        }
      }

      function removeVisible() {
        if (!isDesktop()) return;
        hideOverlay();
        if (disclaimerEl) {
          disclaimerEl.setAttribute('hidden', '');
          disclaimerEl.setAttribute('aria-hidden', 'true');
        }
      }

      if (icon) {
        icon.addEventListener('mouseenter', addVisible);
        icon.addEventListener('focus', addVisible);
      }
      if (disclaimerEl) {
        disclaimerEl.addEventListener('focusin', addVisible);
      }
      group.addEventListener('mouseleave', function (e) {
        if (e.relatedTarget && overlay && overlay.contains(e.relatedTarget)) return;
        if (e.relatedTarget && icon && icon.contains(e.relatedTarget)) return;
        removeVisible();
      });
      if (icon) {
        icon.addEventListener('mouseleave', function (e) {
          if (e.relatedTarget && overlay && overlay.contains(e.relatedTarget)) return;
          removeVisible();
        });
      }
      group.addEventListener('focusout', function (e) {
        if (group.contains(e.relatedTarget)) return;
        removeVisible();
      });
    });

    if (overlay) {
      overlay.addEventListener('mouseenter', function () {
        var activeGroup = sectionEl.querySelector('.campaign-banner-group:hover');
        if (activeGroup) {
          var t = activeGroup.querySelector('.campaign-banners__disclaimer-text');
          var b = activeGroup.querySelector('.campaign-banner');
          if (t && b && t.textContent) positionOverlay(b, t.textContent);
        }
      });
      overlay.addEventListener('mouseleave', hideOverlay);
    }

    var carousel = sectionEl.querySelector('.campaign-banners__carousel');
    if (carousel) {
      function setCampaignNavButtonStates() {
        if (window.innerWidth < 768) return;
        var slider = carousel.querySelector('.slider');
        var prevBtn = carousel.querySelector('button[name="prev"]');
        var nextBtn = carousel.querySelector('button[name="next"]');
        if (!slider || !prevBtn || !nextBtn) return;
        var maxScroll = slider.scrollWidth - slider.clientWidth;
        if (maxScroll <= 1) {
          prevBtn.disabled = true;
          nextBtn.disabled = true;
          return;
        }
        var left = Math.round(slider.scrollLeft);
        prevBtn.disabled = left <= 0;
        nextBtn.disabled = left >= maxScroll - 1;
      }

      function ensureCampaignCarouselStart() {
        if (!carousel.hasAttribute('loaded')) return;
        var slider = carousel.querySelector('.slider');
        if (!slider) return;
        slider.scrollLeft = 0;
        setCampaignNavButtonStates();
      }

      function isBannerTruncated(group) {
        var inner = group.querySelector('.campaign-banner__content-inner--desktop');
        if (!inner) return false;
        var cw = inner.clientWidth;
        inner.style.overflow = 'visible';
        inner.style.maxWidth = 'none';
        var fullW = inner.scrollWidth;
        inner.style.overflow = '';
        inner.style.maxWidth = '';
        return fullW > cw;
      }

      function isAnyVisibleBannerTruncated(slots) {
        var groups = carousel.querySelectorAll('.slider__item.campaign-banner-group');
        for (var i = 0; i < slots && i < groups.length; i++) {
          if (isBannerTruncated(groups[i])) return true;
        }
        return false;
      }

      function updateCampaignSlots() {
        if (!carousel.hasAttribute('loaded') || window.innerWidth < 768) return;
        var slider = carousel.querySelector('.slider');
        if (!slider) return;
        var groups = carousel.querySelectorAll('.slider__item.campaign-banner-group');
        if (groups.length < 2) return;
        var slots = 4;
        for (slots = 4; slots >= 1; slots--) {
          carousel.classList.remove('campaign-banners__carousel--slots-1', 'campaign-banners__carousel--slots-2', 'campaign-banners__carousel--slots-3', 'campaign-banners__carousel--slots-4');
          carousel.classList.add('campaign-banners__carousel--slots-' + slots);
          slider.offsetHeight;
          if (!isAnyVisibleBannerTruncated(slots)) break;
        }
        slots = Math.min(slots, groups.length);
        carousel.classList.remove('campaign-banners__carousel--slots-1', 'campaign-banners__carousel--slots-2', 'campaign-banners__carousel--slots-3', 'campaign-banners__carousel--slots-4');
        carousel.classList.add('campaign-banners__carousel--slots-' + slots);
        carousel.setAttribute('data-slots', slots);
        if (typeof carousel.handleResize === 'function') carousel.handleResize();
        ensureCampaignCarouselStart();
      }

      var mo = new MutationObserver(function () { updateCampaignSlots(); });
      mo.observe(carousel, { attributes: true, attributeFilter: ['loaded'] });
      updateCampaignSlots();

      function runSlotsAfterLayout() {
        requestAnimationFrame(function () {
          requestAnimationFrame(updateCampaignSlots);
        });
      }
      setTimeout(runSlotsAfterLayout, 400);
      window.addEventListener('on:debounced-resize', updateCampaignSlots);

      var slider = carousel.querySelector('.slider');
      if (slider) {
        var scrollTimeout;
        slider.addEventListener('scroll', function () {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(setCampaignNavButtonStates, 150);
        });
      }
    }
  }

  function run() {
    var sections = document.querySelectorAll('.campaign-banners[data-section-id]');
    for (var i = 0; i < sections.length; i++) {
      init(sections[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.detail || !e.detail.sectionId) return;
    var wrapper = document.getElementById('shopify-section-' + e.detail.sectionId);
    if (wrapper) {
      var el = wrapper.querySelector('.campaign-banners[data-section-id]');
      if (el) init(el);
    }
  });
})();
